import { apiFetch } from "./client.ts";

export interface GoogleAccount {
  resource_name: string;
  customer_id: string;
  name?: string;
  currency?: string;
  timezone?: string;
  status?: string;
}

export interface GoogleCampaign {
  id: string;
  name: string;
  status: string;
  channel_type: string;
  bidding_strategy: string;
  daily_budget: number | null;
  impressions: number;
  clicks: number;
  cost: number;
  conversions: number;
  ctr: number;
  avg_cpc: number | null;
}

export interface GoogleDailyMetric {
  date: string;
  impressions: number;
  clicks: number;
  cost: number;
  conversions: number;
}

export const googleAdsApi = {
  listAccounts: () => apiFetch<GoogleAccount[]>("/google-ads/accounts"),
  getAccount: (customerId: string) => apiFetch<GoogleAccount>(`/google-ads/accounts/${customerId}`),
  listCampaigns: (customerId: string, dateRange = "LAST_30_DAYS") =>
    apiFetch<GoogleCampaign[]>(`/google-ads/accounts/${customerId}/campaigns?date_range=${dateRange}`),
  getCampaignMetrics: (customerId: string, campaignId: string, days = 30) =>
    apiFetch<GoogleDailyMetric[]>(`/google-ads/accounts/${customerId}/campaigns/${campaignId}/metrics?days=${days}`),
  pauseCampaign: (customerId: string, campaignId: string) =>
    apiFetch<{ success: boolean; status: string }>(`/google-ads/accounts/${customerId}/campaigns/${campaignId}/pause`, { method: "POST" }),
  enableCampaign: (customerId: string, campaignId: string) =>
    apiFetch<{ success: boolean; status: string }>(`/google-ads/accounts/${customerId}/campaigns/${campaignId}/enable`, { method: "POST" }),
  updateBudget: (customerId: string, campaignId: string, dailyBudget: number) =>
    apiFetch<{ success: boolean; daily_budget: number }>(`/google-ads/accounts/${customerId}/campaigns/${campaignId}/budget`, {
      method: "PUT",
      body: JSON.stringify({ daily_budget: dailyBudget }),
    }),
};
